// extracted by mini-css-extract-plugin
export default {"Main":"Main_Main__-IFo+","padded":"Main_padded__nV0Dj","vCentered":"Main_vCentered__uhaQs","Heading":"Main_Heading__gKiM6","swing-in":"Main_swing-in__KMunG"};